import Endpoint from "../../services/api/endpoint";
import { ICompany } from "../../utils/types/models";
import { createSystemEntityReducer } from "./systemEntityReducer";

export default createSystemEntityReducer<ICompany>(Endpoint.Companies);